import { render, staticRenderFns } from "./drawCutoffrule.vue?vue&type=template&id=b1bf9196&scoped=true&"
import script from "./drawCutoffrule.vue?vue&type=script&lang=js&"
export * from "./drawCutoffrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bf9196",
  null
  
)

export default component.exports